<svg class="svg-icon">
  <use [attr.xlink:href]="'assets/sprite.svg#' + icon()" />
</svg>
